@use "../../styles/breakpoint.module.scss" as *;

.panel {
    grid-column: 2 / span 10;
    padding: var(--spacer-24);

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.header {
    margin-bottom: var(--spacer-32);
}

.title {
    font: var(--font-h-64);
    margin: 0;
    text-align: center;
}

.list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacer-16);
    list-style: none;
    margin: 0;
    padding: 0;

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.item {
    &:first-child {
        grid-column: 1 / -1;
    }

    img {
        display: block;
        width: 100%;
        height: auto;
    }
}
